import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const Name = styled(Typography)``

Name.displayName = 'Name'

export default Name
